import { API } from 'aws-amplify';

export default {
  state: {
    discount: {
      exist: false,
      price: 0,
      startDate: '',
      endDate: '',
    },

  },
  price(price) {
    if (price < 10000) return price;
    return Math.round(price / 10000);
  },
  unit(price) {
    if (price < 10000) return '';
    return 'tenThousand';
  },
  discountPeriod() {
    let period = '';
    if (!this.state.discount.exist) return '';
    if (this.state.discount.startDate.getFullYear() !== new Date().getFullYear()) {
      period += `${this.state.discount.startDate.getFullYear()}/`;
    }
    period += `${this.state.discount.startDate.getMonth() + 1}/${this.state.discount.startDate.getDate()}`;
    if (this.state.discount.startDate.getTime() === this.state.discount.endDate.getTime()) return period;
    period += '-';
    if (this.state.discount.endDate.getFullYear() !== new Date().getFullYear()) {
      period += `${this.state.discount.endDate.getFullYear()}/`;
    }
    period += `${this.state.discount.endDate.getMonth() + 1}/${this.state.discount.endDate.getDate()}`;
    return period;
  },
  discountProc(period, price) {
    this.state.discount = {
      exist: false, price: 0, startDate: '', endDate: '',
    };
    if (!period || period === '') return this.state.discount;
    const range = period.split(',');
    range.forEach((val, index) => {
      const date = val.split('-');
      const startTime = parseInt(date[0], 10);
      const endTime = parseInt(date[1], 10);
      const currentTime = new Date(`${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`).getTime();
      if (startTime === currentTime || endTime === currentTime || (startTime < currentTime && endTime > currentTime)) {
        this.state.discount.exist = true;
        this.state.discount.startDate = new Date(startTime);
        this.state.discount.endDate = new Date(endTime);
        const value = price.split(',');
        this.state.discount.price = value[index];
      }
    });
    return this.state.discount;
  },
  install(items) {
    return new Promise((resolve, reject) => {
      API.post('EcPayAPI', '/product/purchase', { body: items, headers: { 'x-api-key': process.env.VUE_APP_API_GATEWAY_ECPAY_APIKEY } }).then((response) => {
        // console.log(response);
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  uninstall(items) {
    return new Promise((resolve, reject) => {
      API.post('EcPayAPI', '/product/return', { body: items, headers: { 'x-api-key': process.env.VUE_APP_API_GATEWAY_ECPAY_APIKEY } }).then((response) => {
        // console.log(response);
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
};
